import React from "react";
import collabBoardArt from "../assets/student-hub/student-hub-collab-board.png";
import examPapersDeskArt from "../assets/student-hub/student-hub-exam-papers-desk.png";
import quizThinkingArt from "../assets/student-hub/student-hub-quiz-thinking.png";
import wavingWelcomeArt from "../assets/student-hub/student-hub-waving-welcome.png";

export function QuizThinkingArt({ className = "" }: { className?: string }) {
  return <img src={quizThinkingArt} alt="" aria-hidden="true" className={`h-28 w-auto max-w-[5.75rem] shrink-0 object-contain sm:h-40 sm:max-w-[10rem] ${className}`} />;
}

export function CollabGroupArt({ className = "" }: { className?: string }) {
  return <img src={collabBoardArt} alt="" aria-hidden="true" className={`h-auto w-[7.25rem] shrink-0 object-contain sm:w-[14rem] ${className}`} />;
}

export function ExamPapersDeskArt() {
  return <img src={examPapersDeskArt} alt="" aria-hidden="true" className="h-32 w-auto max-w-[9rem] object-contain sm:h-36 sm:max-w-[11rem]" />;
}

export function WavingStudentArt() {
  return <div className="mx-auto flex h-40 w-40 items-center justify-center rounded-[28px] bg-violet-600 p-2 shadow-[0_12px_28px_rgba(91,33,182,.22)]">
    <img src={wavingWelcomeArt} alt="" aria-hidden="true" className="h-full w-auto object-contain" />
  </div>;
}
